import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import SoundUtils from "@/utils/sound-utils";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import CU from "@/utils/c-u";

export class BuyConfirmationPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, description: string, agitation: string, onAcceptCallback: () => unknown) {
        super(scene, canvas, title);
        this.setDepth(5000);

        let clickSound = SoundUtils.addSound(this.scene!, Keys.SOUND_BUTTON_CLICK);

        let descText = new BBCodeText(scene, 0, -130 * CU.S, description, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '20pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 450
            }
        }).setScale(CU.S, CU.S).setOrigin(0.5, 0.5);

        let agitationText = TextUtils.addTextByFamily(scene, agitation.toUpperCase(), 0, 0,
            '#ffd05d', 19, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

        let acceptButton = new SquareButton(scene, 0, 135, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('da'), false, 80, 80);

        acceptButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (this.isOnTop()) {
                if (onAcceptCallback != null) { onAcceptCallback(); }
                this.close();
            }
        });

        this.add([descText, agitationText, acceptButton]);

    }
}
